import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import ContentHeader from '../Layout/ContentHeader'
import LayoutTable from '../Global/LayoutTable'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import {
  DELETE_CONFIG_APP,
  GET_ALL_CONFIG_APP,
} from '../../graphql/ConfigApp/configApp'

const ConfigApp = () => {
  //STATES:
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const [dataToTable, setDataToTable] = useState([])

  //QUERIES:
  const { loading, error, data } = useQuery(GET_ALL_CONFIG_APP, {
    variables: { ...pagePagination },
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getAllConfigApp?.rows.map((item) => {
        let colorVisible = item.visible ? 'text-success' : 'text-gray'
        const divVisible = (
          <i className={`fas fa-check-circle ${colorVisible} fa-2x`} />
        )

        return list.push({
          id: item.id,
          nombre: item.name,
          visible: divVisible,
        })
      })
      setDataToTable(list)
      setTotal(data.getAllConfigApp?.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  return (
    <>
      <ContentHeader
        title="Configuracion App"
        breadcrumb=""
        windowTitle="Configuracion App"
      />
      <LayoutTable
        title="Lista"
        data={dataToTable}
        gql={DELETE_CONFIG_APP}
        requery={GET_ALL_CONFIG_APP}
        exportImportButton={false}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        FilterBarPlaceholder="Buscar por nombre"
        hideDetails
      />
    </>
  )
}

export default ConfigApp
